import { useQuery } from '@tanstack/react-query'
import axiosClient from 'api/axiosClient'
import Marquee from 'react-fast-marquee'
import './styles.scss'
import _ from 'lodash'
import BaseConfig from 'general/constants/DomainConfig'
import { useHostname } from 'general/context/HostnameContext'
export default function Banner() {
  const { data: banners, isLoading } = useQuery({
    staleTime: 1000 * 60 * 5,
    queryKey: ['banner'],
    queryFn: ({ signal }) =>
      axiosClient.get('/notification-marquee/show', {
        signal,
      }),
  })

  if (isLoading) {
    return null
  }
  const hostname = useHostname()
  const { textColorNotiBanner, bgNotiBanner } = BaseConfig[hostname]?.header || {}
  const renderBodyWithLink = (text) => {
    try {
      const urlRegex = /(https?:\/\/[^\s]+)/g
      const parts = text.split(urlRegex)

      return parts.map((part, index) =>
        urlRegex.test(part) ? (
          <a key={index} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        ) : (
          <span key={index}>{part}</span>
        ),
      )
    } catch (error) {
      return text
    }
  }

  // chạy chữ trên đầu trang
  return (
    banners?.data?.length > 0 && (
      <div
        className="d-flex align-items-center px-4"
        style={{
          height: '30px',
          backgroundColor: bgNotiBanner || '#ff0',
          color: textColorNotiBanner || '#ff0000',
        }}
      >
        <Marquee className="custom-marquee" pauseOnHover speed={50}>
          {banners?.data.map((banner) => (
            <div
              className="mx-40 font-size-normal font-weight-bold"
              key={banner.notificationMarqueeId}
            >
              <li>
                {banner?.title}: {renderBodyWithLink(banner?.body)}
              </li>
            </div>
          ))}
        </Marquee>
      </div>
    )
  )
}
